import * as React from 'react'
import { Store } from 'redux'

import { IRouteConfig } from '../../typings/routes'
import { fetchBannerData } from '../actions/marketing/banner'
import { IRootState } from '../reducers'
import { getMatchedRoute } from '../utils/location/router'
import { ICommonLocation } from '../utils/location/types'

export interface IUseFetchBannerData {
  store: Store<IRootState>
  location: ICommonLocation
  routes: IRouteConfig[]
}

const useFetchBannerData = ({
  store,
  location,
  routes
}: IUseFetchBannerData) => {
  const {
    common: { currentSite }
  } = store.getState()
  const { route, params } = React.useMemo(
    () => getMatchedRoute({ currentSite, location, routes }),
    [currentSite, location, routes]
  )
  const category =
    params.category && !Array.isArray(params.category)
      ? params.category.split('/')[0]
      : undefined
  const pageType = route.pageType

  React.useEffect(() => {
    if (route.pageType) {
      store.dispatch(
        fetchBannerData({
          apiAppUrlPrefix: '',
          category
        })
      )
    }
  }, [category, pageType])
}

export default useFetchBannerData
